/* sitelock */
var sitelockTrue = function sitelockTrue() {
  var elementToHide = document.querySelector('.section-fall-winter-sitelock');
  if (elementToHide) {
    elementToHide.style.display = 'none';
  }
  var heroToHide = document.querySelector('.normal_site');
  if (heroToHide) {
    heroToHide.style.display = 'none';
  }
  var heroToShow = document.querySelector('.sl_display_none');
  if (heroToShow) {
    heroToShow.style.display = 'block';
  }
  var elementToDisplay = document.querySelector('.lcdk_main_section');
  if (elementToDisplay) {
    elementToDisplay.style.display = 'block';
  }
};
var sitelockFalse = function sitelockFalse() {
  var hideElement = document.querySelector('.sl_display_none');
  if (hideElement) {
    hideElement.style.display = 'none';
  }
  var hideElement2 = document.querySelector('.lcdk_main_section');
  if (hideElement2) {
    hideElement2.style.display = 'none';
  }
};
export var initSitelock = function initSitelock(hasSitelockClass) {
  if (hasSitelockClass) {
    sitelockTrue();
  } else {
    sitelockFalse();
  }
};

//  sitelock message when new email signup
var queryString = window.location.search;
var message = document.getElementById('ss24-message');
if (queryString.includes('contact')) {
  message.style.display = 'block';
}